import { FC, ReactNode } from 'react';

import PartnerHero from '../components/unauth/PartnerHero';
import PartnerMarketingPanel from '../components/unauth/PartnerMarketingPanel';
import PartnerTrustStrip from '../components/unauth/PartnerTrustStrip';
import UnauthFooter from '../components/unauth/UnauthFooter';
import UnauthHeader from '../components/unauth/UnauthHeader';

type UnauthShellProps = {
  children: ReactNode;
  /** Marketing landing for login/signup; chrome is header + footer only. */
  variant?: 'marketing' | 'chrome';
};

/** Logged-out layout: full marketing landing with the auth panel in the hero, or plain chrome. */
export const UnauthShell: FC<UnauthShellProps> = ({ children, variant = 'marketing' }) => {
  if (variant === 'chrome') {
    return (
      <div className="flex min-h-screen w-full flex-col bg-surface-canvas">
        <UnauthHeader showNav={false} />
        <main className="flex-1">{children}</main>
        <UnauthFooter />
      </div>
    );
  }

  return (
    <div className="flex min-h-screen w-full flex-col bg-white">
      <UnauthHeader />
      <main className="flex-1">
        <PartnerHero>{children}</PartnerHero>
        <PartnerTrustStrip />
        <PartnerMarketingPanel />
      </main>
      <UnauthFooter />
    </div>
  );
};

export default UnauthShell;
